// Menu Toggler

export function menuToggler() {

  const transition = duration => new Promise(resolve => setTimeout(resolve, duration))

  const trigger = document.querySelector('[data-navigation-toggle]')
  let isOpen = false
  let locked = false

  trigger.addEventListener('click', async () => {
    if (locked) return
    locked = true

    if (isOpen) {
      document.body.classList.remove('menu-open')
      await transition(300)
      document.body.classList.remove('mobile-pre-open')
      isOpen = false

    } else {
      document.body.classList.add('mobile-pre-open')
      await transition(50)
      document.body.classList.add('menu-open')
      isOpen = true
      document.querySelectorAll('.block-projects.is-active').forEach(el => {
        el.classList.remove('is-active')
      })
    }

    locked = false
  })

}

// Fix 100vh Problem on Mobile browsers
export function mobileViewHeightFix () {
  const element = document.querySelector('.full-screen-height')

  if (element) {
    const viewportHeight = element.getBoundingClientRect().height
    element.style.height = viewportHeight + 'px'
  }
}

export function onLoadOrResize() {
  const winWidth = window.innerWidth
  if ( winWidth >= 1024 && document.body.classList.contains('mobile-menu-open') ) {
    document.body.classList.remove('mobile-menu-open');
  }
}

export function startupTheme() {
  document.body.style.setProperty(
    '--scrollBarWidth',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );

  document.addEventListener("DOMContentLoaded", () => {
    menuToggler()
    mobileViewHeightFix()

    window.addEventListener('load', onLoadOrResize)
    window.addEventListener('resize', onLoadOrResize)
  });
}

console.log(`%c
       ___                         ___           ___           ___
      /  /\\                       /__/\\         /__/\\         /  /\\
     /  /:/_                      \\  \\:\\        \\  \\:\\       /  /::|
    /  /:/ /\\    ___     ___       \\  \\:\\        \\  \\:\\     /  /:/\:|
   /  /:/_/::\\  /__/\\   /  /\\  ___  \\  \\:\\   _____\\__\\:\\   /  /:/|:|__
  /__/:/__\\/\\:\\ \\  \\:\\ /  /:/ /__/\\  \\__\\:\\ /__/::::::::\\ /__/:/ |:| /\\
  \\  \\:\\ /~~/:/  \\  \\:\\  /:/  \\  \\:\\ /  /:/ \\  \\:\\~~\\~~\\/ \\__\\/  |:|/:/
   \\  \\:\\  /:/    \\  \\:\\/:/    \\  \\:\\  /:/   \\  \\:\\  ~~~      |  |:/:/
    \\  \\:\\/:/      \\  \\::/      \\  \\:\\/:/     \\  \\:\\          |  |::/
     \\  \\::/        \\__\\/        \\  \\::/       \\  \\:\\         |  |:/
      \\__\\/                       \\__\\/         \\__\\/         |__|/

 www.glunz.ch
 `, `font-family: monospace`);
